var exports = {
  "y": "x93eb46d8--d71f28--pin",
};

module.exports = exports;
